import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Door = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M11.25 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.25M20 12H8.75M20 12l-4.5 4.5M20 12l-4.5-4.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M11.25 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.25M20 12H8.75M20 12l-4.5 4.5M20 12l-4.5-4.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    )}
  </IconBase>
);
